module.exports = __webpack_public_path__ + "img/材料力学6_11.bb0392ef.jpg";